import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function NotFound() {
    const navigate = useNavigate();
    return (
        <div className='page-size flex-center gap-4 p-4'>
            <p>
                404 Not Found
            </p>
            <button className="btn btn-primary" onClick={() => navigate("/")}>
                Go Home
            </button>
        </div>
    )
}
